import "./AboutAnushthan.css";
import ourDnaVideo from "../assests/videos/our_dna.mp4";

// const OurDna = () => {

//   return (
//     <>
//       <section className="">
//         <div className="container" id="layer1">
//           <div className="row mt-100">
//             <div className="col-12">
//               <h1 className="title-text">Our</h1>
//             </div>
//             <div className="col-12">
//               <h1 className="title-text">DNA</h1>
//             </div>
//           </div>

//           <div className="row mt-3">
//             <div
//               id="dna-1"
//               className="col-md-4 col-12 mx-1 px-5 bg-warning step fw-bolder fs-5 text-center"
//             >
//               Creative in Process. Strategic in Thinking. Relentless in
//               Delivery.
//             </div>

//             <div
//               id="dna-2"
//               className="col-md-4 col-12 px-5 mx-1 step bg-primary fw-bolder fs-5 text-center"
//             >
//               Focused on measurable outcomes— not vanity metrics.
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-12">
//               <img className="img-dna" src={ourDNAimage} alt="DNA"></img>
//             </div>
//           </div>

//           <div className="row mt-3 justify-content-end">
//             <div
//               id="dna-3"
//               className="col-md-4 col-12 px-5 fw-bolder fs-5 text-start mx-1 step bg-primary"
//             >
//               A cross-functional team of designers, developers, marketers,
//               analysts and consultants.
//             </div>

//             <div
//               id="dna-4"
//               className="col-md-4 col-12 px-5 fw-bolder text-start fs-5 mx-1 step bg-warning"
//             >
//               Passionate about solving real problems through custom,
//               tech-forward solutions.
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default OurDna;

import React, { useState, useEffect } from "react";

const OurDna = () => {
  const [scrollY, setScrollY] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);

    // Trigger animations on mount
    setTimeout(() => setIsVisible(true), 100);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const chevronData = [
    {
      text: "Creative in Process. Strategic in Thinking. Relentless in Delivery.",
      color: "#f3f3f3",
      position: "top-left",
      delay: 0,
    },
    {
      text: "Focused on measurable outcomes—not vanity metrics.",
      color: "#f3f3f3",
      position: "top-right",
      delay: 400,
    },
    {
      text: "A cross-functional team of designers, developers, marketers, analysts and consultants.",
      color: "#f3f3f3",
      position: "bottom-left",
      delay: 400,
    },
    {
      text: "Passionate about solving real problems through custom, tech-forward solutions.",
      color: "#f3f3f3",
      position: "bottom-right",
      delay: 800,
    },
  ];

  const dnaSections = [
    {
      heading: "Creative",
      headingBlack: " in Process.",
      description: "Strategic in Thinking.\nRelentless in Delivery.",
      color: "text-yellow-400",
    },
    {
      heading: "Focused on",
      headingBlack: " on",
      description: "measurable outcomes\nnot vanity metrics.",
      color: "text-yellow-400",
    },
    {
      heading: "Passionate",
      headingBlack: " about",
      description:
        "solving real problems\nthrough custom, tech\nforward solutions.",
      color: "text-yellow-400",
    },
    {
      heading: "A cross-functional",
      headingBlack: " team",
      description:
        "of designers, developers,\nmarketers, analysts and\nconsultants.",
      color: "text-yellow-400",
    },
  ];

  // const ChevronBox = ({ text, color, position, delay }) => {
  //   const isLeft = position.includes("left");
  //   const isTop = position.includes("top");

  //   return (
  //     <div
  //       className={`col-md-6 d-flex ${
  //         isLeft ? "justify-content-start" : "justify-content-end"
  //       } mb-4`}
  //       style={{
  //         transform: isVisible
  //           ? "translateX(0)"
  //           : `translateX(${isLeft ? "-100px" : "100px"})`,
  //         opacity: isVisible ? 1 : 0,
  //         transition: `all 0.8s ease-out ${delay}ms`,
  //       }}
  //     >
  //       <div
  //         className="chevron-container position-relative"
  //         style={{
  //           width: "100%",
  //           maxWidth: "500px",
  //           height: "180px",
  //           cursor: "pointer",
  //           transform: "translateZ(0)",
  //         }}
  //       >
  //         <div
  //           className="chevron-box d-flex shadow align-items-center justify-content-center text-white fw-bold p-3 h-100 position-relative overflow-hidden"
  //           style={{
  //             background: color,
  //             clipPath: isLeft
  //               ? "polygon(0 0, calc(100% - 30px) 0, 100% 50%, calc(100% - 30px) 100%, 0 100%, 30px 50%)"
  //               : "polygon(30px 0, 100% 0, calc(100% - 30px) 50%, 100% 100%, 30px 100%, 0 50%)",
  //             fontSize: "clamp(0.9rem, 2vw, 1.1rem)",
  //             textAlign: "center",
  //             lineHeight: "1.4",
  //             boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  //             transition: "all 0.3s ease",
  //             borderRadius: "8px",
  //             color: "black",
  //           }}
  //           onMouseEnter={(e) => {
  //             e.currentTarget.style.transform = "translateY(-5px) scale(1.02)";
  //             e.currentTarget.style.boxShadow = "0 20px 40px rgba(0,0,0,0.3)";
  //           }}
  //           onMouseLeave={(e) => {
  //             e.currentTarget.style.transform = "translateY(0) scale(1)";
  //             e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.2)";
  //           }}
  //         >

  //           <div
  //             className="position-absolute top-0 start-0 w-100 h-100"
  //             style={{
  //               background:
  //                 "linear-gradient(45deg, transparent 30%, rgba(255,255,255,1) 50%, transparent 70%)",
  //               transform: "translateX(-100%)",
  //               animation: `shine 1s ease-in-out infinite ${delay}ms`,
  //             }}
  //           />
  //           <span className="position-relative text-black z-index-1 fs-5 fw-bolder content">
  //             {text}
  //           </span>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ backgroundColor: "#fff" }}
    >
      <div className="container">
        <div className="bg-white p-4 p-lg-5 d-flex flex-column flex-lg-row align-items-center">
          {/* Left side content */}
          <div className="col-12 col-lg-7 mb-4 mb-lg-0">
            <h1 className="text-dark fw-bold display-3 mb-4">
              OUR <span className="text-yellow">DNA</span>
            </h1>

            <div className="row g-4">
              {dnaSections.map((section, index) => (
                <div key={index} className="col-12 col-sm-6">
                  <h3 className="fw-bold fs-4 mb-2">
                    <span className="text-yellow">{section.heading}</span> {section.headingBlack}
                  </h3>
                  <p
                    className="text-dark fs-4"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {section.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Right side image */}
          <div className="col-12 col-lg-5 d-flex justify-content-center justify-content-lg-end">
            <div className="rounded-5">
              <video width="100%" height="auto" autoPlay loop muted playsInline className="rounded-5 rotate-90">
                <source src={ourDnaVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
    // <div className="min-vh-100 position-relative overflow-hidden">

    /* <div className="container-fluid py-5">
        <div className="container" id="layer1">
          <div className="row">
            <div className="col-12">
              <h1 className="title-text">Our</h1>
            </div>
            <div className="col-12">
              <h1 className="title-text">DNA</h1>
            </div>
          </div>
        </div>
        <div className="container mt-3">
          <div className="row align-items-center min-vh-100">
            <div className="col-12">
              <div className="row">
                <ChevronBox {...chevronData[0]} />
                <ChevronBox {...chevronData[1]} />
              </div>
            </div>

            <div className="col-12 d-flex justify-content-center mb-5">
              <div
                className="central-element position-relative"
                style={{
                  width: "1200px",
                  height: "500px",
                  transform: isVisible
                    ? "scale(1) rotateY(0deg)"
                    : "scale(0.5) rotateY(180deg)",
                  opacity: isVisible ? 1 : 0,
                  transition:
                    "all 1.2s cubic-bezier(0.175, 0.885, 0.32, 1.275) 800ms",
                }}
              >
                <div
                  className="twisted-element position-absolute w-100 h-100"
                  style={{
                    borderRadius: "50px",
                    animation: "twist 8s ease-in-out infinite",
                    transform: "perspective(1000px) rotateX(15deg)",
                  }}
                >
                  <div className="position-absolute w-100 h-100 bg-our-dna" />

                  {[...Array(12)].map((_, i) => (
                    <div
                      key={i}
                      className="position-absolute rounded-circle"
                      style={{
                        width: `${Math.random() * 8 + 4}px`,
                        height: `${Math.random() * 8 + 4}px`,
                        background: `hsl(${Math.random() * 360}, 70%, 70%)`,
                        left: `${Math.random() * 100}%`,
                        top: `${Math.random() * 100}%`,
                        animation: `float 4s ease-in-out infinite ${
                          Math.random() * 2
                        }s`,
                        boxShadow: "0 0 10px rgba(255,255,255,0.5)",
                      }}
                    />
                  ))}
                </div>

                <div
                  className="position-absolute w-100 h-100"
                  style={{
                    background:
                      "linear-gradient(45deg, transparent 40%, rgba(255,255,255,0.3) 50%, transparent 60%)",
                    borderRadius: "50px",
                    clipPath:
                      "polygon(10% 0%, 90% 0%, 100% 35%, 90% 100%, 10% 100%, 0% 65%)",
                    animation: "reflect 6s ease-in-out infinite",
                    pointerEvents: "none",
                  }}
                />
              </div>
            </div>

            <div className="col-12">
              <div className="row">
                <ChevronBox {...chevronData[2]} />
                <ChevronBox {...chevronData[3]} />
              </div>
            </div>
          </div>
        </div>
      </div> */

    // <style jsx>{`
    //   @keyframes twist {
    //     0%,
    //     100% {
    //       transform: perspective(1000px) rotateX(15deg) rotateY(0deg)
    //         rotateZ(0deg);
    //     }
    //     25% {
    //       transform: perspective(1000px) rotateX(25deg) rotateY(10deg)
    //         rotateZ(5deg);
    //     }
    //     50% {
    //       transform: perspective(1000px) rotateX(15deg) rotateY(0deg)
    //         rotateZ(-10deg);
    //     }
    //     75% {
    //       transform: perspective(1000px) rotateX(5deg) rotateY(-10deg)
    //         rotateZ(5deg);
    //     }
    //   }

    //   @keyframes shine {
    //     0% {
    //       transform: translateX(-100%) skewX(-15deg);
    //     }
    //     100% {
    //       transform: translateX(200%) skewX(-15deg);
    //     }
    //   }

    //   @keyframes reflect {
    //     0%,
    //     100% {
    //       opacity: 0.3;
    //       transform: translateX(-50px);
    //     }
    //     50% {
    //       opacity: 0.8;
    //       transform: translateX(50px);
    //     }
    //   }

    //   @keyframes float {
    //     0%,
    //     100% {
    //       transform: translateY(0px) rotate(0deg);
    //       opacity: 0.7;
    //     }
    //     50% {
    //       transform: translateY(-20px) rotate(180deg);
    //       opacity: 1;
    //     }
    //   }

    //   .z-index-1 {
    //     z-index: 1;
    //   }

    //   .chevron-container::before {
    //     content: "";
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     right: 0;
    //     bottom: 0;
    //     background: linear-gradient(
    //       45deg,
    //       transparent,
    //       rgba(255, 255, 255, 0.1),
    //       transparent
    //     );
    //     opacity: 0;
    //     transition: opacity 0.3s ease;
    //     pointer-events: none;
    //     border-radius: 8px;
    //   }

    //   .chevron-container:hover::before {
    //     opacity: 1;
    //   }

    //   @media (max-width: 768px) {
    //     .central-element {
    //       width: 90vw !important;
    //       height: 200px !important;
    //     }

    //     .chevron-box {
    //       font-size: 0.9rem !important;
    //       height: 100px !important;
    //     }
    //   }

    //   body {
    //     overflow-x: hidden;
    //   }
    // `}</style>
    // </div>
  );
};

export default OurDna;
